import React from "react";
import { useNavigate } from "react-router-dom";

function Admin() {
  const navigate = useNavigate();

  return (
    <div>
      <h1>Admin Dashboard</h1>
      <button onClick={() => navigate("/admin/ptl-preview")}>프리뷰 어드민</button>
      <button onClick={() => navigate("/admin/team")}>팀 어드민</button>
    </div>
  );
}

export default Admin;